import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useRef, useCallback } from 'react';
import { config as configCore } from '@industriousapps/excelkits-core';
import { DataSource } from '../../hooks/useDataSourceSelect';
import Button from '@/components/Button';
import WorkbooksMegaSelect from '../WorkbooksMegaSelect';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FileUploadIcon = function FileUploadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5558_661)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9154 0.286791C11.4142 0.166451 10.8944 0.166698 10.2065 0.167026L6.57197 0.16706C5.69992 0.167046 4.98019 0.167035 4.3939 0.214937C3.78496 0.264689 3.2252 0.371467 2.69942 0.639366C1.88405 1.05482 1.22113 1.71773 0.80568 2.5331C0.537782 3.05888 0.431004 3.61864 0.381252 4.22758C0.33335 4.81387 0.333361 5.53359 0.333374 6.40564V15.5951C0.333361 16.4672 0.33335 17.1869 0.381252 17.7732C0.431004 18.3821 0.537782 18.9419 0.80568 19.4677C1.22113 20.2831 1.88405 20.946 2.69942 21.3614C3.2252 21.6293 3.78496 21.7361 4.3939 21.7859C4.98019 21.8338 5.6999 21.8337 6.57194 21.8337H11.4281C12.3002 21.8337 13.0199 21.8338 13.6062 21.7859C14.2151 21.7361 14.7749 21.6293 15.3007 21.3614C16.116 20.946 16.779 20.2831 17.1944 19.4677C17.4623 18.9419 17.5691 18.3821 17.6188 17.7732C17.6667 17.1869 17.6667 16.4672 17.6667 15.5951L17.6667 7.62726C17.6671 6.93936 17.6673 6.41957 17.547 5.91832C17.4408 5.47617 17.2657 5.05347 17.0281 4.66576C16.7588 4.22623 16.3911 3.85887 15.9044 3.37268L14.4611 1.92934C13.9749 1.44268 13.6075 1.07497 13.168 0.80562C12.7803 0.568029 12.3576 0.392943 11.9154 0.286791ZM10.0834 2.33373H6.61671C5.68875 2.33373 5.05793 2.33457 4.57033 2.37441C4.09538 2.41321 3.8525 2.48355 3.68306 2.56988C3.27538 2.77761 2.94392 3.10906 2.73619 3.51675C2.64986 3.68618 2.57953 3.92907 2.54072 4.40402C2.50088 4.89162 2.50004 5.52243 2.50004 6.45039V15.5504C2.50004 16.4784 2.50088 17.1092 2.54072 17.5968C2.57953 18.0717 2.64986 18.3146 2.73619 18.484C2.94392 18.8917 3.27538 19.2232 3.68306 19.4309C3.8525 19.5172 4.09538 19.5876 4.57033 19.6264C5.05793 19.6662 5.68875 19.6671 6.61671 19.6671H11.3834C12.3113 19.6671 12.9422 19.6662 13.4298 19.6264C13.9047 19.5876 14.1476 19.5172 14.317 19.4309C14.7247 19.2232 15.0562 18.8917 15.2639 18.484C15.3502 18.3146 15.4206 18.0717 15.4594 17.5968C15.4992 17.1092 15.5 16.4784 15.5 15.5504V7.75039H13.3334C11.5384 7.75039 10.0834 6.29532 10.0834 4.50039V2.33373ZM15.0233 5.58373C14.8932 5.42978 14.6852 5.21767 14.2943 4.82672L13.0071 3.53947C12.6161 3.14852 12.404 2.94061 12.25 2.81042V4.50039C12.25 5.0987 12.7351 5.58373 13.3334 5.58373H15.0233Z",
        fill: "#3A3D4D"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.76603 9.15031C9.34296 8.72724 8.65704 8.72724 8.23397 9.15031L6.0673 11.317C5.64423 11.74 5.64423 12.426 6.0673 12.849C6.49037 13.2721 7.1763 13.2721 7.59937 12.849L7.91667 12.5317V16.4163C7.91667 17.0147 8.40169 17.4997 9 17.4997C9.59831 17.4997 10.0833 17.0147 10.0833 16.4163V12.5317L10.4006 12.849C10.8237 13.2721 11.5096 13.2721 11.9327 12.849C12.3558 12.426 12.3558 11.74 11.9327 11.317L9.76603 9.15031Z",
        fill: "#3A3D4D"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5558_661",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "22",
          fill: "white"
        })
      })
    })]
  }));
};

FileUploadIcon.defaultProps = {
  width: "18",
  height: "22",
  viewBox: "0 0 18 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const SUPPORTED_FILE_TYPES = configCore.spreadsheets.supportedFileTypes;

const EditorModalsFooter = _ref => {
  let {
    teamId,
    workbookId,
    dataSource,
    isDisabled = false,
    onChange,
    onChangeWorkbook
  } = _ref;
  return /*#__PURE__*/_jsx("footer", {
    className: clsx(displayModalStyles.footer, styles.container),
    children: dataSource === DataSource.TEAM_WORKBOOKS ? /*#__PURE__*/_jsx(WorkbooksMegaSelect, {
      workbookId: workbookId,
      teamId: teamId,
      onSelect: onChangeWorkbook
    }) : /*#__PURE__*/_jsx(FileUploadButton, {
      onChange: onChange,
      disabled: isDisabled
    })
  });
};

const FileUploadButton = _ref2 => {
  let {
    onChange,
    disabled
  } = _ref2;
  const fileInputRef = useRef(null); // Get 1st file from change event & emit up

  const handleChange = useCallback(evt => {
    const input = evt.target;
    const file = (input.files || [])[0];
    if (input) input.value = ''; // Clear selection

    if (file) onChange(file); // Emit upload
  }, [onChange]);
  return /*#__PURE__*/_jsxs("label", {
    htmlFor: "file-upload",
    className: styles.main,
    children: [/*#__PURE__*/_jsx(Button, {
      size: "large",
      variant: "tertiaryDark",
      role: "button",
      rightIcon: /*#__PURE__*/_jsx(FileUploadIcon, {}),
      onClick: () => {
        var _fileInputRef$current;

        return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
      },
      disabled: disabled,
      children: "Upload File"
    }), /*#__PURE__*/_jsx("input", {
      id: "file-upload",
      ref: fileInputRef,
      type: "file",
      onChange: handleChange,
      accept: SUPPORTED_FILE_TYPES.map(ft => `.${ft}`.trim()).join(', '),
      hidden: true
    }), /*#__PURE__*/_jsxs("p", {
      className: styles.leading,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.heading,
        children: "XLSX files recommended."
      }), ' ', "Supports: ", SUPPORTED_FILE_TYPES.slice(1).join(', ')]
    })]
  });
};

export default EditorModalsFooter;